import { Reveal } from "@/components/Reveal";
import { PROCESS_STEPS } from "@/content/site";

export const Prozess = () => {
  return (
    <section id="prozess" data-testid="process-section" className="scroll-mt-[var(--header-h)] section-pad">
      <div className="site-container">
        <Reveal>
          <p className="kicker">Wie wir arbeiten</p>
          <h2 className="mt-4 text-2xl font-semibold tracking-[-0.02em] text-foreground sm:text-3xl">
            Persönlich. Pragmatisch. Zuverlässig.
          </h2>
          <p className="mt-4 max-w-[58ch] text-sm leading-relaxed text-muted-foreground sm:text-base">
            Kein Callcenter. Wir kommen zu Ihnen, beraten ehrlich und setzen mit unserem eigenen Team um.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {PROCESS_STEPS.map((step, index) => (
            <Reveal key={step.num} delay={index * 0.08}>
              <div className="group relative flex flex-col">
                <div className="mb-4 flex items-center gap-4">
                  <span className="font-tech text-[42px] font-semibold tracking-[-0.04em] text-[hsl(var(--brand-steelblue))]/90 tabular-nums">
                    {step.num}
                  </span>
                  <div className="h-px flex-1 bg-border/60 group-hover:bg-[hsl(var(--brand-steelblue))]/40 transition-colors" />
                </div>
                <h3 className="text-lg font-semibold tracking-[-0.01em] text-foreground">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                  {step.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-sm text-muted-foreground">
            Der Ablauf ist bewusst einfach gehalten. Gute Arbeit braucht keine komplizierten Prozesse.
          </p>
        </Reveal>
      </div>
    </section>
  );
};